module.exports = __webpack_public_path__ + "img/liu.2f694215.png";